import { InputLabel, SelectLabel } from '../../../../../common/components/form/fields';
import { FORM_RULES } from "../../../../../helpers/validations";

const inputStyle = { fontSize: "1.6rem", padding: 20, borderRadius: ".5rem" };
const style = { textAlign: "left", fontSize: "1.6rem", paddingBottom: 0 };

export default (optionsState) => [
	{
		component: InputLabel,
		type: "text",
		name: "name",
        label: "Nome",
        placeholder: "Nome da cidade",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "lat",
        label: "Latitude",
        placeholder:"00:00",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "lon",
        label: "Longitude",
        placeholder:"00:00",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "timezone",
        label: "Fuso horário",
        placeholder:"+00:00",
		cols: "12 12 6 6",
		validate: [FORM_RULES.required],
		style,
		inputStyle
	},
	{
		component: InputLabel,
		type: "text",
		name: "country_letters",
        label: "Sigla do país",
        placeholder:"BR",
		cols: "12 12 6 6",
		style,
		inputStyle
	},
	{
		component: SelectLabel,
		type: "text",
		name: "state",
		label: "Estado",
		options: optionsState(),
        placeholder: "Selecione o estado",
		cols: "12 12 12 12",
		style,
		selectStyle: inputStyle
	}
];
